import * as actions from './actions';

const initialState = {
  available: true,
  loading: false,
  error: null,
  initial: false,
  // Free results
  reading: null,
  // Premium results
  premiumData: null,
  premiumLoading: false,
  premiumPending: false,
  premiumEtaAt: null,
  compatibility: null,
  // Catalog
  numbers: [],
  // Feedback
  readingEvaluated: false,
  // Anonymous checkout / pay-to-generate (contrato de PayToGenerateFlow)
  pendingReadingId: null,
  pendingLoading: false,
  pendingFullName: null,
  checkoutLoading: false,
  checkoutError: null,
  purchaseVerified: false,
  paidReadingId: null,
  paidEmail: null,
  paidReading: null,
};

export default function numerologyReducer(state = initialState, action) {
  switch (action.type) {
    // Availability
    case actions.NUMEROLOGY_AVAILABILITY_REQUEST:
      return { ...state, loading: true, error: null };
    case actions.NUMEROLOGY_AVAILABILITY_SUCCESS:
      return { ...state, available: action.payload.available, loading: false, initial: true, error: null };
    case actions.NUMEROLOGY_AVAILABILITY_ERROR:
      return { ...state, loading: false, error: action.payload };

    // Calculate
    case actions.NUMEROLOGY_CALCULATE_REQUEST:
      return { ...state, loading: true, error: null, reading: null };
    case actions.NUMEROLOGY_CALCULATE_SUCCESS:
      return { ...state, reading: action.payload.reading, loading: false, error: null };
    case actions.NUMEROLOGY_CALCULATE_ERROR:
      return { ...state, loading: false, error: action.payload };

    // Premium
    case actions.NUMEROLOGY_PREMIUM_REQUEST:
      return { ...state, premiumLoading: true, premiumPending: false, premiumEtaAt: null, error: null };
    case actions.NUMEROLOGY_PREMIUM_SUCCESS:
      return { ...state, premiumData: action.payload.data, premiumLoading: false, premiumPending: false, error: null };
    case actions.NUMEROLOGY_PREMIUM_PENDING:
      return { ...state, premiumPending: true, premiumEtaAt: action.payload.etaAt, premiumData: null, premiumLoading: false, error: null };
    case actions.NUMEROLOGY_PREMIUM_ERROR:
      return { ...state, premiumLoading: false, error: action.payload };

    // Compatibility
    case actions.NUMEROLOGY_COMPATIBILITY_REQUEST:
      return { ...state, premiumLoading: true, error: null };
    case actions.NUMEROLOGY_COMPATIBILITY_SUCCESS:
      return { ...state, compatibility: action.payload.data, premiumLoading: false, error: null };
    case actions.NUMEROLOGY_COMPATIBILITY_ERROR:
      return { ...state, premiumLoading: false, error: action.payload };

    // Like
    case actions.NUMEROLOGY_LIKE_REQUEST:
      return { ...state };
    case actions.NUMEROLOGY_LIKE_SUCCESS:
      return { ...state, readingEvaluated: true };

    // Numbers catalog
    case actions.NUMEROLOGY_NUMBERS_REQUEST:
      return { ...state, loading: true, error: null };
    case actions.NUMEROLOGY_NUMBERS_SUCCESS:
      return { ...state, numbers: action.payload.numbers, loading: false, error: null };
    case actions.NUMEROLOGY_NUMBERS_ERROR:
      return { ...state, loading: false, error: action.payload };

    // Pending reading creation (pay-to-generate landing)
    case actions.CREATE_PENDING_NUMEROLOGY_REQUEST:
      return { ...state, pendingLoading: true, pendingReadingId: null, checkoutError: null };
    case actions.CREATE_PENDING_NUMEROLOGY_SUCCESS:
      return {
        ...state,
        pendingLoading: false,
        pendingReadingId: action.payload.readingId,
        pendingFullName: action.payload.fullName,
      };
    case actions.CREATE_PENDING_NUMEROLOGY_FAILURE:
      return { ...state, pendingLoading: false, checkoutError: action.payload, error: action.payload };

    // Checkout (Stripe)
    case actions.NUMEROLOGY_CHECKOUT_REQUEST:
      return { ...state, checkoutLoading: true, checkoutError: null, error: null };
    case actions.NUMEROLOGY_CHECKOUT_SUCCESS:
      return { ...state, checkoutLoading: false };
    case actions.NUMEROLOGY_CHECKOUT_FAILURE:
      return { ...state, checkoutLoading: false, checkoutError: action.payload, error: action.payload };

    // Checkout (PayPal)
    case actions.NUMEROLOGY_PAYPAL_ORDER_REQUEST:
      return { ...state, checkoutLoading: true, checkoutError: null, error: null };
    case actions.NUMEROLOGY_PAYPAL_ORDER_SUCCESS:
      return { ...state, checkoutLoading: false };
    case actions.NUMEROLOGY_PAYPAL_ORDER_FAILURE:
      return { ...state, checkoutLoading: false, checkoutError: action.payload, error: action.payload };

    // Verify purchase (Stripe / PayPal share success shape)
    case actions.NUMEROLOGY_VERIFY_PURCHASE_REQUEST:
    case actions.NUMEROLOGY_VERIFY_PAYPAL_REQUEST:
      return { ...state, premiumLoading: true, checkoutLoading: true, error: null };
    case actions.NUMEROLOGY_VERIFY_PURCHASE_SUCCESS:
    case actions.NUMEROLOGY_VERIFY_PAYPAL_SUCCESS:
      return {
        ...state,
        premiumLoading: false,
        checkoutLoading: false,
        purchaseVerified: true,
        paidReadingId: action.payload.reading_id,
        paidEmail: action.payload.email,
        reading: action.payload.reading || state.reading,
        paidReading: action.payload.reading || state.paidReading,
        premiumData: action.payload.premium || state.premiumData,
      };
    case actions.NUMEROLOGY_VERIFY_PURCHASE_FAILURE:
    case actions.NUMEROLOGY_VERIFY_PAYPAL_FAILURE:
      return { ...state, premiumLoading: false, checkoutLoading: false, checkoutError: action.payload, error: action.payload };

    // Reset
    case actions.NUMEROLOGY_RESET:
      return { ...initialState };

    default:
      return state;
  }
}
